import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-statistics-manage",
  "use": "icon-statistics-manage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-statistics-manage\"><defs><style type=\"text/css\"></style></defs><path d=\"M476.6140625 134.6815625c-231.36 0-419.0015625 187.6415625-419.0015625 419.04 0 231.4753125 187.6415625 419.0784375 419.0015625 419.0784375 126.8353125 0 240.365625-56.409375 317.203125-145.3828125l-317.203125-273.714375V134.6815625z\" p-id=\"2399\" /><path d=\"M966.3875 470.2971875C966.3875 238.765625 778.840625 51.2 547.443125 51.2v419.0971875H966.3875zM547.443125 529.29874999l317.0690625 273.65812501c63.455625-73.44 101.8753125-169.0940625 101.8753125-273.65812501H547.443125z\" p-id=\"2400\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/statistics-manage.svg
// module id = Hw+N
// module chunks = 101